module.exports = __webpack_public_path__ + "static/media/YM87_5.3317b36e.jpg";